import { ArrowUp, Instagram, Mail, Phone } from "lucide-react";
import { FadeIn } from "./Reveal";

export const Footer = ({ onNavigate }) => (
  <footer data-testid="footer-section" className="relative overflow-hidden bg-ink text-ivory">
    <div className="relative z-10 mx-auto max-w-[1600px] px-6 py-20 sm:px-10 lg:px-16">
      <FadeIn>
        <div className="flex flex-wrap items-end justify-between gap-10">
          <div>
            <img
              src="/assets/mark-white.png"
              alt="SORA events house"
              className="w-24 sm:w-28"
            />
          </div>
          <p className="max-w-xs text-[11px] font-medium uppercase leading-loose tracking-[0.3em] text-ivory/60">
            Brand Launches • Corporate Events • Private Events
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.15}>
        <div className="mt-16 flex flex-wrap items-center justify-between gap-8 border-t border-ivory/15 pt-10">
          <div className="flex items-center gap-8">
            <a
              href="https://instagram.com/soraeventshouse"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Instagram"
              className="text-ivory/70 transition-colors duration-500 hover:text-pastel"
            >
              <Instagram size={18} strokeWidth={1.5} />
            </a>
            <a
              href="mailto:hello@soraeventshouse.com"
              data-testid="footer-email-link"
              aria-label="Email"
              className="text-ivory/70 transition-colors duration-500 hover:text-pastel"
            >
              <Mail size={18} strokeWidth={1.5} />
            </a>
            <a
              href="tel:+971567291129"
              data-testid="footer-phone-link"
              aria-label="Phone"
              className="text-ivory/70 transition-colors duration-500 hover:text-pastel"
            >
              <Phone size={18} strokeWidth={1.5} />
            </a>
          </div>
          <button
            onClick={() => onNavigate("#home")}
            data-testid="footer-back-to-top-button"
            className="group flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.35em] text-ivory/70 transition-colors duration-500 hover:text-pastel"
          >
            Back to top
            <ArrowUp
              size={14}
              strokeWidth={1.5}
              className="transition-transform duration-500 group-hover:-translate-y-1"
            />
          </button>
        </div>
      </FadeIn>

      <div className="mt-12 flex flex-wrap items-center justify-between gap-4 text-[10px] font-medium uppercase tracking-[0.3em] text-ivory/40">
        <p>© 2026 SORA EVENTS HOUSE</p>
        <p>Dubai, UAE</p>
      </div>
    </div>
  </footer>
);
